export default {
    blacklist: 'บัญชีดำ',
    createBlacklist: 'สร้างบัญชีดำ',
    blacklistLists: 'รายชื่อบัญชีดำ',
    blacklistActivity: 'บันทึกการมาเยือน',
    blacklistName: 'ชื่อบัญชีดำ',
    dateCreate: 'วันที่สร้าง',
    status: 'สถานะ',
    action: '',
    search: 'ค้นหา',
    activityLog: 'ประวัติกิจกรรม',
    viewBlacklistProfile: 'ดูข้อมูลบัญชีดำ',
    profile: 'ข้อมูล',
    name: 'ชื่อ',
    blacklistReason: 'สาเหตุ',
    deleteBlacklist: 'ลบบัญชีดำ',
    wantToDelete: 'คุณแน่ใจว่าต้องการที่จะลบบัญชีดำ',
    congratulation: 'ยินดีด้วย',
    blacklistIsDeleted: 'บัญชีดำถูกลบแล้ว',
    date: 'วันที่',
    detectTime: 'เวลาที่พบ',
    image: 'รูป',
    location: 'สถานที่',
    temperatureShort: 'อุณหภูมิ',
    somethingWrong: 'เกิดข้อผิดพลาด',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด Excel',
    searchText: 'ค้นหาจากชื่อบัญชีดำ'
}
